/**
 * Billing constants shared across the frontend.
 *
 * Keep these values in sync with:
 * application/backend/firebase/functions/services/subscription.js
 */

export const CREDIT_SHARE_MARKUP = 0.5; // 50% markup over raw API cost
export const CREDITS_PER_USD = 100 / 50; // 1 USD of user allowance == 2 credits (conversion constant for pod credits)

export const usdToCredits = (value) => {
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }
  return Math.max(1, Math.round(value * CREDITS_PER_USD));
};

export const creditsToUSD = (credits) => {
  if (!Number.isFinite(credits) || credits <= 0) {
    return 0;
  }
  return Number((credits / CREDITS_PER_USD).toFixed(2));
};
